export default __webpack_public_path__ + "static/media/ng.86452401.png";